var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-overlay" }, [
      _c("div", { staticClass: "loading-content" }, [
        _c("p", { staticClass: "loading-text" }, [
          _c("span", [_vm._v("Đang xử lý, vui lòng đợi")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot" }, [_vm._v(".")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot" }, [_vm._v(".")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }